import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal,
  TemplateRef,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MarketplaceStoreFacade } from '@core/store/services/marketplace.store.facade';
import { TProductEntity } from '@core/utils/products/entities/product.entity';
import { cartContentAnimations } from '@shared/cart/cart-content/cart-content.animations';
import { CartContentImports } from '@shared/cart/cart-content/cart-content.imports';
import { EnMaxWidthScreen, EnMinWidthScreen } from '@shared/constants/screen-breakpoints';
import { distinctUntilChanged, map, Observable } from 'rxjs';

@Component({
  selector: 'noda-cart-content',
  templateUrl: './cart-content.component.html',
  styleUrl: './cart-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: CartContentImports,
  animations: cartContentAnimations,
})
export class CartContentComponent {
  private storeFacade: MarketplaceStoreFacade = inject(MarketplaceStoreFacade);

  public arrowTemplateRef: InputSignal<TemplateRef<HTMLElement>> =
    input<TemplateRef<HTMLElement>>();

  public toggleClicked: OutputEmitterRef<void> = output();
  public productToggleClicked: OutputEmitterRef<[TProductEntity, boolean]> = output();
  public startClicked: OutputEmitterRef<void> = output();

  protected selectedProducts$: Observable<TProductEntity[]> = this.storeFacade.selectedProducts$;
  protected recommendedProducts$: Observable<TProductEntity[]> =
    this.storeFacade.recommendedProductsExceptSelected$.pipe(
      map(products => products?.slice(0, 4)),
    );

  public isModalFormOpen: InputSignal<boolean> = input<boolean>(false);

  protected counter: Signal<number> = toSignal(
    this.selectedProducts$.pipe(
      map(products => products?.length ?? 0),
      distinctUntilChanged(),
    ),
    { initialValue: 0 },
  );

  protected readonly enMinWidthScreen: typeof EnMinWidthScreen = EnMinWidthScreen;
  protected readonly enMaxWidthScreen: typeof EnMaxWidthScreen = EnMaxWidthScreen;

  @HostBinding('@toggleCart')
  private toggleCart: unknown;
}
